import { Injectable } from '@angular/core';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../../shared/utils/response-util.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { ChainBrandHttpServiceInterface } from './chain-brand.http-service.interface';
import { Chain } from '../../models/chain-brand/chain';
import { Brand } from '../../models/chain-brand/brand';
import { AppAuthHttpService } from '../../../http/app.auth.http.service';
import { List } from 'immutable';

@Injectable()
export class ChainBrandHttpService implements ChainBrandHttpServiceInterface {

  private chainsEndpoint = `${this.environment.baseUrl}/api/lookup/chains`;
  private brandsEndpoint = '/brands';

  constructor(private http: AppAuthHttpService,
    private environment: EnvironmentConfiguration,
    private responseUtilService: ResponseUtilService) {
  }

  getChains(): Observable<Chain[] | Response> {
    return this.http.get(`${this.chainsEndpoint}`)
      .map(response => response.json().map(chain => new Chain(chain)))
      .catch(error => this.responseUtilService.handleError(error))
      .share();
  }

  getBrands(chainCode: string): Observable<Brand[] | Response> {
    return this.http.get(`${this.chainsEndpoint}/${chainCode}${this.brandsEndpoint}`)
      .map(response =>  response.json().map(brand => new Brand(brand)))
      .catch(error => this.responseUtilService.handleError(error))
      .share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/chainbrand/chain-brand.http-service.ts